export enum BusinessModule {
    NULL = '',
    CatalogueItem = 'CatalogueItem',
    Codebook = 'Codebook',
    District = 'District',
    Need = 'Need',
    Party = 'Party',
    PartyActivity = 'PartyActivity',
    PartyCareProvider = 'PartyCareProvider',
    PartyContact = 'PartyContact',
    PartyNeed = 'PartyNeed',
    PartyNeedGroup = 'PartyNeedGroup',
    PartySocialInquiry = 'PartySocialInquiry',
    PartySocialInquiryGroup = 'PartySocialInquiryGroup',
    SocialInquiry = 'SocialInquiry',
    Town = 'Town',
    UnitOfMeasureConversion = 'UnitOfMeasureConversion',
    UnitOfMeasure = 'UnitOfMeasure',
    WorkTaskEvaluation = 'WorkTaskEvaluation',
    WorkTaskEvaluationGroup = 'WorkTaskEvaluationGroup',
    WorkTaskRule = 'WorkTaskRule',
    WorkTaskStatement = 'WorkTaskStatement',
    WorkTask = 'WorkTask',
    PartyWorkDay = 'PartyWorkDay',
    Tenant = 'Tenant',
    TenantUser = 'TenantUser',
    TenantConnection = 'TenantConnection',
    TenantInvitation = 'TenantInvitation',
    ApplicationUser = 'ApplicationUser',
    File = 'File',
    Folder = 'Folder',
    CareAllowence = 'CareAllowence',
    TerminationReason = 'TerminationReason',
    PriceList = 'PriceList',
    Billing = 'Billing',
    Payment = 'Payment',
    VisitRule = 'VisitRule',
    AdminTenant = 'AdminTenant',
    AdminUser = 'AdminUser',
    SystemUser = 'SystemUser',
    AdminTenantUser = 'AdminTenantUser',
}
